import { Box, Link } from "@chakra-ui/react";
import { faPhone } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  featureName: string;
}

export const SplashScreenReachout = ({ featureName }: Props) => {
  const phoneNumber = "0344 0800 8424";

  return (
    <Box fontSize={"xl"}>
      <Box>
        Reach out to your account manager to request adding the {featureName} to
        your Lead Management Account.
      </Box>
      <Box display={"flex"} alignItems={"center"} gap={4} marginTop={4}>
        <FontAwesomeIcon icon={faPhone} />
        <Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
      </Box>
    </Box>
  );
};
